import React, { useContext, useState, useEffect } from "react";
import { InfoContext, Match, Season } from "../components/InfoContext";
import LoadingCircle from "../components/LoadingCircle";
import MatchDaysCarousel from "../components/MatchDaysCarousel";

const UpcomingMatches: React.FC = () => {
  const { seasons, getTeamById, isLoading } = useContext(InfoContext);
  const [selectedSeason, setSelectedSeason] = useState<Season | null>(null);

  useEffect(() => {
    if (seasons.length > 0) {
      const latestSeason = seasons.sort((a, b) => b.id - a.id)[0];
      setSelectedSeason(latestSeason);
    }
  }, [seasons]);

  if (isLoading) {
    return (
      <div className="flex flex-col justify-center items-center py-10 w-full h-full text-white bg-gradient-to-r from-blue-750 to-blue-850">
        <LoadingCircle />
      </div>
    );
  }

  if (!selectedSeason) {
    return <div></div>;
  }

  const formatDate = (dateString: string | null) => {
    if (!dateString) return "TBD";

    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "TBD";

    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear().toString().slice(-2);

    return `${day}/${month}/${year}`;
  };

  const allMatches = selectedSeason.matches.filter((match) =>
    match.match_stage.includes("GROUP")
  );

  const groupedByWeek: Record<number, Match[]> = allMatches.reduce(
    (acc: Record<number, Match[]>, match) => {
      const week = match.week;
      if (!acc[week]) {
        acc[week] = [];
      }
      acc[week].push(match);
      return acc;
    },
    {}
  );

  const sortedWeeks = Object.keys(groupedByWeek)
    .map(Number)
    .sort((a, b) => a - b);

  return (
    <div className="w-full h-screen">
      <h1 className="text-3xl font-bold mb-6 mt-4 text-center text-white">
        Matches
      </h1>
      <div className="mb-6 flex justify-center">
        <select
          id="season-select"
          value={selectedSeason ? selectedSeason.id : ""}
          onChange={(e) => {
            const seasonId = Number(e.target.value);
            const season = seasons.find((s) => s.id === seasonId);
            setSelectedSeason(season || null);
          }}
          className="w-full max-w-32 px-3 py-2 border rounded-xl"
        >
          <option value="" className="te" disabled>
            Select a season
          </option>
          {seasons
            .sort((a, b) => b.id - a.id)
            .map((season) => (
              <option key={season.id} value={season.id}>
                {season.name}
              </option>
            ))}
        </select>
      </div>

      {sortedWeeks.length === 0 ? (
        <p>No matches found for this season.</p>
      ) : (
        <MatchDaysCarousel groupedByWeek={groupedByWeek} />
      )}
    </div>
  );
};
export default UpcomingMatches;
